define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/table/matrix/Path"
], function(array,declare,PathMatrix) {

	return declare(PathMatrix, {
		_filterNodes: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: remove any responses of steps that aren't open
			return array.filter(nodes, function(node) {
				var step = ctx.cache.getNode(node.__Parent__, true);
				return step.State == "ActionItemStep.State:OPEN";
			});
		}
	});
});
